import React from "react";

import Addons from "../../pages/mine_craft/Addons";
import ShowAddon from "../../pages/mine_craft/Addons/Show";

import Skins from "../../pages/mine_craft/Skins";
import ShowSkin from "../../pages/mine_craft/Skins/Show";

import Worlds from "../../pages/mine_craft/Worlds";
import ShowWorld from "../../pages/mine_craft/Worlds/Show";

import AddonTemplates from '../../pages/mine_craft/AddonTemplates';
import ShowAddonTemplate from "../../pages/mine_craft/AddonTemplates/Show";

import MainSkins from '../../pages/mine_craft/MainSkins';
import ShowMainSkin from "../../pages/mine_craft/MainSkins/Show";

import Users from "../../pages/mine_craft/Users";
import ShowUser from "../../pages/mine_craft/Users/Show";

import Reports from '../../pages/mine_craft/Reports';

import Tips from '../../pages/mine_craft/Tips';
import YoutubeVideos from '../../pages/mine_craft/YoutubeVideos';
import TipSteps from '../../pages/mine_craft/TipSteps';

import Bundles from '../../pages/mine_craft/Bundles';
import ShowBundle from '../../pages/mine_craft/Bundles/Show';

import Notifications from '../../pages/mine_craft/Notifications';
import ShowNotification from '../../pages/mine_craft/Notifications/Show';

import Devices from '../../pages/mine_craft/Devices';
import ShowDevice from '../../pages/mine_craft/Devices/Show';

import Challenges from '../../pages/mine_craft/Challenges';
import ShowChallenge from '../../pages/mine_craft/Challenges/Show';
import Banners from "../../pages/mine_craft/Banners";
import Frames from "../../pages/mine_craft/Frames";
import Avatars from "../../pages/mine_craft/Avatars";
import UsernameStyles from "../../pages/mine_craft/UsernameStyles";
import BannedIps from "../../pages/mine_craft/BannedIps";

const minecraftRoutes = [
  // Crafty Craft
  { path: '/crafty_craft/addons', element: <Addons appId={1} /> },
  { path: '/crafty_craft/addons/trending', element: <Addons appId={1} /> },
  { path: '/crafty_craft/addons/popular', element: <Addons appId={1} /> },
  { path: '/crafty_craft/addons/recents', element: <Addons appId={1} /> },
  { path: '/crafty_craft/addons/unpublished', element: <Addons appId={1} /> },
  { path: '/crafty_craft/addons/:id', element: <ShowAddon /> },

  { path: '/crafty_craft/skins', element: <Skins /> },
  { path: '/crafty_craft/skins/:id', element: <ShowSkin /> },

  { path: '/crafty_craft/worlds', element: <Worlds /> },
  { path: '/crafty_craft/worlds/:id', element: <ShowWorld /> },

  { path: '/crafty_craft/addon_templates', element: <AddonTemplates /> },
  { path: '/crafty_craft/addon_templates/:id', element: <ShowAddonTemplate /> },

  { path: '/crafty_craft/main_skins', element: <MainSkins /> },
  { path: '/crafty_craft/main_skins/:id', element: <ShowMainSkin /> },

  { path: '/crafty_craft/users', element: <Users appId={1} /> },
  { path: '/crafty_craft/users/:id', element: <ShowUser /> },

  { path: '/crafty_craft/reports', element: <Reports /> },
  { path: '/crafty_craft/reports/addons', element: <Reports /> },
  { path: '/crafty_craft/reports/users', element: <Reports /> },
  { path: '/crafty_craft/reports/comments', element: <Reports /> },

  { path: '/crafty_craft/youtube_videos', element: <YoutubeVideos appId={1} /> },

  { path: '/crafty_craft/tips', element: <Tips entityId={1} /> },
  { path: '/crafty_craft/tip_steps', element: <TipSteps /> },

  { path: '/crafty_craft/bundles', element: <Bundles appId={1} /> },
  { path: '/crafty_craft/bundles/:id', element: <ShowBundle /> },

  { path: '/crafty_craft/notifications', element: <Notifications appId={1} /> },
  { path: '/crafty_craft/notifications/:id', element: <ShowNotification /> },

  { path: '/crafty_craft/devices', element: <Devices appId={1} /> },
  { path: '/crafty_craft/devices/:id', element: <ShowDevice /> },

  { path: '/crafty_craft/challenges', element: <Challenges appId={1} /> },
  { path: '/crafty_craft/challenges/:id', element: <ShowChallenge /> },

  { path: '/crafty_craft/banners', element: <Banners appId={1} /> },
  { path: '/crafty_craft/frames', element: <Frames appId={1} /> },
  { path: '/crafty_craft/avatars', element: <Avatars appId={1} /> },
  { path: '/crafty_craft/username_styles', element: <UsernameStyles appId={1} /> },
  { path: '/crafty_craft/banned_ips', element: <BannedIps /> },

  // Mods Craft
  { path: '/mods_craft/addons', element: <Addons appId={2} /> },
  { path: '/mods_craft/addons/trending', element: <Addons appId={2} /> },
  { path: '/mods_craft/addons/popular', element: <Addons appId={2} /> },
  { path: '/mods_craft/addons/recents', element: <Addons appId={2} /> },
  { path: '/mods_craft/addons/unpublished', element: <Addons appId={2} /> },
  { path: '/mods_craft/addons/:id', element: <ShowAddon /> },

  { path: '/mods_craft/skins', element: <Skins /> },
  { path: '/mods_craft/skins/:id', element: <ShowSkin /> },

  { path: '/mods_craft/worlds', element: <Worlds /> },
  { path: '/mods_craft/worlds/:id', element: <ShowWorld /> },

  { path: '/mods_craft/addon_templates', element: <AddonTemplates /> },
  { path: '/mods_craft/addon_templates/:id', element: <ShowAddonTemplate /> },

  { path: '/mods_craft/main_skins', element: <MainSkins /> },
  { path: '/mods_craft/main_skins/:id', element: <ShowMainSkin /> },

  { path: '/mods_craft/users', element: <Users appId={2} /> },
  { path: '/mods_craft/users/:id', element: <ShowUser /> },

  { path: '/mods_craft/reports', element: <Reports /> },
  { path: '/mods_craft/reports/addons', element: <Reports /> },
  { path: '/mods_craft/reports/users', element: <Reports /> },
  { path: '/mods_craft/reports/comments', element: <Reports /> },

  { path: '/mods_craft/youtube_videos', element: <YoutubeVideos appId={2} /> },

  { path: '/mods_craft/tips', element: <Tips entityId={2} /> },
  { path: '/mods_craft/tip_steps', element: <TipSteps /> },

  { path: '/mods_craft/bundles', element: <Bundles appId={2} /> },
  { path: '/mods_craft/bundles/:id', element: <ShowBundle /> },

  { path: '/mods_craft/notifications', element: <Notifications appId={2} /> },
  { path: '/mods_craft/notifications/:id', element: <ShowNotification /> },

  { path: '/mods_craft/devices', element: <Devices appId={2} /> },
  { path: '/mods_craft/devices/:id', element: <ShowDevice /> },

  { path: '/mods_craft/challenges', element: <Challenges appId={2} /> },
  { path: '/mods_craft/challenges/:id', element: <ShowChallenge /> },

  { path: '/mods_craft/banners', element: <Banners appId={2} /> },
  { path: '/mods_craft/frames', element: <Frames appId={2} /> },
  { path: '/mods_craft/avatars', element: <Avatars appId={2} /> },
  { path: '/mods_craft/username_styles', element: <UsernameStyles appId={2} /> },
  { path: '/mods_craft/banned_ips', element: <BannedIps /> },
];

export default minecraftRoutes;
